import React, { Component } from 'react'
import style from './style.module.less'
import { hashHistory } from 'react-router'
import { observer, inject } from 'mobx-react'
import cls from 'classnames'
import MenuItem from '../Item'
import mainStore from '@components/Main/store'

@inject('menuStore')
@observer
class Setting extends Component {
  isInSettingMenu = false
  isInSettingSubMenu = false

  state = {
    showSettingSubMenu: false
  }

  handleSubMenuShow = () => {
    if (this.isInSettingMenu || this.isInSettingSubMenu) {
      this.setState({ showSettingSubMenu: true })
    } else if (!this.isInSettingMenu && !this.isInSettingSubMenu) {
      this.setState({ showSettingSubMenu: false })
    }
  }

  render() {
    const { isSettingSelected, SETTING_MENU } = this.props.menuStore
    const [setting] = SETTING_MENU
    const { isOpenHcy } = mainStore

    return (
      <div>
        <MenuItem
          item={setting}
          onMouseEnter={() => {
            this.isInSettingMenu = true
            this.handleSubMenuShow()
          }}
          onMouseLeave={() => {
            this.isInSettingMenu = false
            this.handleSubMenuShow()
          }}
          isActive={this.state.showSettingSubMenu}
          isMenuSelected={isSettingSelected}
        />

        <div
          className={cls(style.settingSubMenu, {
            [style['menu-hidden']]: !this.state.showSettingSubMenu
          })}
          onMouseEnter={() => {
            this.isInSettingSubMenu = true
            this.handleSubMenuShow()
          }}
          onMouseLeave={() => {
            this.isInSettingSubMenu = false
            this.handleSubMenuShow()
          }}
        >
          {setting.sub.filter(Boolean).map(item => {
            const { id, title, path, render } = item
            const node = (
              <div
                key={id}
                className={style.menu}
                onClick={() => {
                  this.setState({ showSettingSubMenu: false })
                  this.props.menuStore.onMenuClick(id, 'setting')
                  hashHistory.push(path)
                }}
              >
                <span>{title}</span>
              </div>
            )

            if (render) {
              return render(item, node, { isOpenHcy })
            }

            return node
          })}
        </div>
      </div>
    )
  }
}

export default Setting
